import { ReactNode } from "react";

import { AccountProvider } from "./account";
import { AuthProvider } from "./auth";
import { FeatureToggleProvider } from "./featureToggle";
import { ModalProvider } from "./modal";
import { ToastProvider } from "./toast";
import { TooltipProvider } from "./tooltip";
import { UploadContextProvider } from "./upload";
import { UserProvider } from "./user";

interface Props {
  children: ReactNode;
}

// Register state related providers here
export const AppStateProviders = ({ children }: Props): JSX.Element => (
  <AuthProvider>
    <UserProvider>{children}</UserProvider>
  </AuthProvider>
);

// Register UI related providers here
export const AppUIProviders = ({ children }: Props): JSX.Element => (
  <ToastProvider>
    <ModalProvider>
      <UploadContextProvider>
        <AccountProvider>
          <FeatureToggleProvider>
            <TooltipProvider>{children}</TooltipProvider>
          </FeatureToggleProvider>
        </AccountProvider>
      </UploadContextProvider>
    </ModalProvider>
  </ToastProvider>
);
